<template>
  <div>
    <div class="elevation-0 pa-4 ma-0" style="background:white; border-radius:3px;">
      <v-list-tile-title class="subheading">
        Subject: {{ subject }}
      </v-list-tile-title>
      <div class="elevation-0 pa-4 ma-0" style="background:white; border-radius:3px;">
        <MessageFrame :messageId="messageId" v-if="messageId"/>
      </div>
    </div>
  </div>
</template>

<script>
import MessageFrame from "@/components/comms/MessageFrame.vue"

export default {
  name: "Conversations",
  data: () => ({
    actionText: {
      remove_participants: "Removed",
      add_participants: "Added"
    },
    emailRecipients: []
  }),
  props: ["eventDateObj"],
  computed: {
    subject() {
      return this.eventDateObj && this.eventDateObj.params ? this.eventDateObj.params.subject : undefined
    },
    messageId() {
      return this.eventDateObj && this.eventDateObj.params ? this.eventDateObj.params.id : undefined
    }
  },
  components: {
    MessageFrame
  },
  methods: {
    emailRecipientUsed: function(email) {
      if (this.emailRecipients.includes(email)) return true
      this.emailRecipients.push(email)
      return false
    }
  }
}
</script>
<style>
.timeline-entry-iframe {
  width: 100%;
  border: none;
  outline: none;
}
</style>
